module.exports = __webpack_public_path__ + "media/images/marisol/marisol3-ebe6757c4ec496498bcd5aeede5de5ee.png";